/* eslint-disable no-unused-expressions */
import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "axios";
import { toast } from 'react-toastify';

import { API_TOKEN, AI_BACKEND_API, API_URL, AI_BACKEND_API_2 } from "../../Config/secrets";
import { downloadExport } from "../../Utils";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  addBrand: null,
  matchingLoading: false,
  totalBrands: 0,
  companies: [],
  allBrands: {},
  selectedFilters: {
    page: 1,
    // filters: { "target group": ["Men"] },
    filters: {},
  },
  scrappedData: {
    id: null,
    predictions: null,
    website: null,
    facebook: null,
    instagram: null,
    linkedin: null,
  },
  matchResults: [],
  selectedBrand: {},
  brandRating: {},
  engagements: {},
  totalEngagements: {},
  nextToBrandsByKey: {},
  nextToBrandsLoading: false,
};

const slice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    setSelectedBrand(state, action) {
      state.selectedBrand = action.payload;
    },
    startMatchingLoading(state) {
      state.matchingLoading = true;
    },
    startNextToBrandsLoading(state) {
      state.nextToBrandsLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    setSelectedFilters(state, action) {
      state.selectedFilters = action.payload;
    },

    resetBrand: () => initialState,

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.matchingLoading = false;
      state.nextToBrandsLoading = false;
      state.matchResults = [];
    },

    // GET EVENTS
    getAllBrandsSuccess(state, action) {
      state.error = null;
      state.totalBrands = action.payload.total;
      (state.allBrands = {
        ...state.allBrands,
        [action.payload.page]: action.payload.data,
      });
      state.isLoading = false;
    },
    getFilteredBrandsSuccess(state, action) {
      state.error = null;
      (state.totalBrands = action.payload.total),
        (state.allBrands = {
          [action.payload.page]: action.payload.data,
        });
      state.isLoading = false;
    },

    getAddBrandSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.addBrand = action.payload;
    },

    getUpdateBrandSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      if (action.payload.isSelected) {
        state.selectedBrand = action.payload.data;
      }
    },

    getCompaniesSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.companies = action.payload;
    },

    getScrappedDataForBrandSuccess(state, action) {
      const { id, platform, scrappedData } = action.payload;

      state.isLoading = false;
      state.error = null;

      // Create a copy of the existing scrappedData
      const updatedScrappedData = { ...state.scrappedData, id };

      // Check the platform value and update the corresponding data
      if (platform === "facebook") {
        updatedScrappedData.facebook = scrappedData.scraped_data;
      } else if (platform === "instagram") {
        updatedScrappedData.instagram = scrappedData.scraped_data;
      } else if (platform === "linkedin") {
        updatedScrappedData.linkedin = scrappedData.scraped_data;
      } else if (platform === "website") {
        updatedScrappedData.website = scrappedData.scraped_data;
      } else {
        // Default case or handle other platforms accordingly
        updatedScrappedData.predictions = scrappedData.scraped_data;
      }

      state.scrappedData = updatedScrappedData;
    },

    resetScrappedData(state) {
      state.scrappedData = initialState.scrappedData;
    },

    getMatchResultsSuccess(state, action) {
      state.error = null;
      state.isLoading = false;
      state.matchingLoading = false;
      state.matchResults = action.payload;
    },

    getBrandRatingSuccess(state, action) {
      state.brandRating = {
        ...state.brandRating,
        ...action.payload,
      };
    },
    getFiltersSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.filters = action.payload;
    },
    getBrandEngagementsSuccess(state, action) {
      state.error = null;
      const { tab, page, total, data } = action.payload;

      if (!state.engagements[tab]) {
        state.engagements[tab] = {};
      }

      state.engagements[tab][page] = data;
      state.totalEngagements[tab] = total;
      state.isLoading = false;
    },
    getRetailerEngagementsSuccess(state, action) {
      state.error = null;
      const { tab, page, total, data } = action.payload;

      if (!state.engagements[tab]) {
        state.engagements[tab] = {};
      }

      state.engagements[tab][page] = data;
      state.totalEngagements[tab] = total;
      state.isLoading = false;
    },
    getNextToBrandsSuccess(state, action) {
      const { key, data } = action.payload;
      state.error = null;
      state.nextToBrandsByKey[key] = data;
      state.nextToBrandsLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { resetBrand, getAddBrandSuccess, getAllBrandsSuccess, getUpdateBrandSuccess, setSelectedBrand, getBrandRatingSuccess, setSelectedFilters } =
  slice.actions;

// ----------------------------------------------------------------------

const header = {
  Authorization: API_TOKEN,
};

export function getCompanies() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/company/get`, {
        headers: header,
      });
      // // console.log('CREATE BRAND', data, response);

      dispatch(slice.actions.getCompaniesSuccess(response.data?.data));
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function deleteCompany(comapany_id) {
  return async (dispatch) => {
    try {
      const response = await axios.delete(`${API_URL}/company/delete`, {
        params: { company_id: comapany_id },
        headers: header
      });

      // // console.log('CREATE BRAND', data, response);

      if (response?.data?.statusCode === 200) {
        toast.success('Company Deleted')
      } else {
        toast.error('Something went wrong')
      }

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function assignBrandToCompany(data) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/brands/assign`, data, {
        headers: header,
      });

      if (response.data?.statusCode === 200) {
        toast.success("Brand Company Updated");
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function UnassignBrandToCompany(data) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/brands/unassign`, data, {
        headers: header,
      });

      if (response.data?.statusCode === 200) {
        toast.success("Brand Un-assigned to company");
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function addBrandFunc({ type, data }) {
  return async (dispatch) => {
    try {
      const endpoint = type === 'brand' ? 'create_brand' : 'create_retailer';
      const payload = type === 'brand' ? { brands: data } : { retailers: data };
      const response = await axios.post(`${AI_BACKEND_API}/${endpoint}`, payload, {
        headers: header,
      });

      const { status, results } = response?.data || {};
      const created = results?.created || [];
      const existed = results?.existed || [];
      const label = type === 'brand' ? 'brand' : 'retailer';

      if (status === 200) {
        if (created.length && !existed.length) {
          toast.success(`${created.length} ${label}(s) created successfully`);
        } else if (created.length && existed.length) {
          toast.success(`${created.length} ${label}(s) created. ${existed.length} already existed.`);
        } else if (!created.length && existed.length) {
          toast.warning(`All ${existed.length} ${label}(s) already exist.`);
        }
        dispatch(slice.actions.getAddBrandSuccess(response.data));
        return response?.data;
      }

      toast.error(response?.data?.message || 'Something went wrong');
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      toast.error(error?.response?.data?.message || 'Something went wrong');
      return error?.response?.data;
    }
  };
}

export function addBrandFuncViaFile(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${AI_BACKEND_API}/brand/create_brand_with_file`, data, {
        headers: header,
      });
      dispatch(slice.actions.getAddBrandSuccess(response.data));
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function updateBrandData({ data, isSelected, cb }) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/brands/update`, data, {
        headers: header,
      });
      console.log("UPDATE BRAND RESPONSE", data, response);
      if (response.data?.statusCode === 200) {
        toast.success("Brand Updated");
        if (typeof cb === 'function') {
          cb();
        }
      }
      if (response.data?.statusCode !== 200) {
        toast.error(response?.data?.message);
      }
      dispatch(slice.actions.getUpdateBrandSuccess({ isSelected, data: response?.data?.data }));
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function rematch({ id, type, cb }) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${AI_BACKEND_API}/${type === 'brand' ? 'match_making_brand' : 'match_making_retailer'}`, { id }, {
        headers: header,
      });
      if (cb) {
        cb()
      }

      toast.success(`Total ${response?.data?.total_matches || 0} matches found`)

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function refetch({ type, ids }) {
  return (dispatch) => {
    if (type !== 'brand' && type !== 'retailer') {
      toast.error('Fetch is only supported for brands and retailers');
      return;
    }

    const endpoint = type === 'brand' ? 'fetch_brand' : 'fetch_retailer';
    const payload = type === 'brand' ? { brand_ids: ids } : { retailer_ids: ids };

    toast.info('Fetch is in progress. This may take a few minutes to complete.');

    axios.post(`https://testadmin.hyperscout.io/ai-backend-temp/${endpoint}`, payload, {
      headers: header,
    }).catch((error) => {
      dispatch(slice.actions.hasError(error?.response?.data));
      toast.error(error?.response?.data?.message || 'Fetch failed');
    });
  };
}

export function resetNextTo(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${AI_BACKEND_API}/reset_nextto`, { id }, {
        headers: header,
      });

      toast.success("Brands in your space reset successfully");
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      toast.error(error?.response?.data?.message || "Reset brands in your space failed");
      return error?.response?.data;
    }
  };
}

export function updateBrandMatches({ data, cb }) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/brands/update-brand-matches`, data, {
        headers: header,
      });
      if (cb) {
        cb()
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function updateNextToCompetitorMatches({ data, cb }) {
  return async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/brands/update-next-to-competitor-matches`, data, {
        headers: header,
      });
      if (cb) {
        cb()
      }
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getBrandSocialData(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${AI_BACKEND_API}/brand/get_brand`, data, {
        headers: header,
      });
      dispatch(slice.actions.getUpdateBrandSuccess(response.data));
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

// Request body for the brands table; the Excel export sends the same one.
function brandsListPayload(page, filters, query, take, source, retaielrId, createdDateRange, updatedDateRange, specificBrandsSearches) {
  let payload = { skip: page, take };
  const isFilters = Object.keys(filters || {}).length > 0;

  if (isFilters) {
    payload.filters = true;
    payload = { ...payload, ...filters };
  }
  if (query) payload.query = query;
  if (source) payload.source = source
  if (retaielrId) payload.exclude_retailer_id_matches = retaielrId
  if (createdDateRange?.startDate) payload.createdStartDate = createdDateRange.startDate
  if (createdDateRange?.endDate) payload.createdEndDate = createdDateRange.endDate
  if (updatedDateRange?.startDate) payload.updatedStartDate = updatedDateRange.startDate
  if (updatedDateRange?.endDate) payload.updatedEndDate = updatedDateRange.endDate
  if (specificBrandsSearches?.length > 0) payload.specific_brands_searches = specificBrandsSearches
  return payload;
}

// Every brand matching the table's current search/filters/dates, as .xlsx.
export function exportBrands(filters, query, createdDateRange = null, updatedDateRange = null, specificBrandsSearches = null) {
  return async () => {
    const payload = brandsListPayload(1, filters, query, 10, null, null, createdDateRange, updatedDateRange, specificBrandsSearches);
    return downloadExport(`${API_URL}/brands/export`, payload, header, `brands_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };
}

export function getAllBrands(page = 1, filters, query, take = 10, source = null, retaielrId = null, createdDateRange = null, updatedDateRange = null, specificBrandsSearches = null) {
  return async (dispatch) => {
    try {
      const payload = brandsListPayload(page, filters, query, take, source, retaielrId, createdDateRange, updatedDateRange, specificBrandsSearches);

      const response = await axios.post(`${API_URL}/brands/get-overall-brands`, payload, {
        headers: header,
      });

      console.log('GET BRANDS', response.data)
      // if (response?.data?.statusCode === 200) {
      dispatch(
        slice.actions.getAllBrandsSuccess({
          page,
          total: response?.data?.data?.count || 0,
          data: response?.data?.data?.data || [],
        })
      );
      return response?.data?.data?.data;
      // }
    } catch (error) {
      toast.error(error?.message || "Failed to fetch wholesalers", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}


export function getFilters() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/brands/data-to-filter-over-all`, {
        headers: header,
      });

      if (response?.statusCode === 400 && !response?.data) {
        toast.error(response?.message || "Something went wrong", { autoClose: 3000 });
        return;
      }

      if (response?.data?.statusCode === 200) {
        dispatch(slice.actions.getFiltersSuccess(response?.data?.data));
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response));
      return error?.response;
    }
  };
}

export function getBrand(id) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setSelectedBrand({}));

      const response = await axios.get(`${API_URL}/brands/brand-get/${id}`, {
        headers: header,
      });
      // // console.log(`${crmApiUrl}/leads/brand_get/${id}`, response);
      if (response?.data?.statusCode === 200 && response?.data?.data) {
        dispatch(slice.actions.setSelectedBrand(response?.data?.data));
      }
    } catch (error) {
      // console.log("GET USER FAILD", error);
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getBrandById(id) {
  return async () => {
    try {
      const response = await axios.get(`${API_URL}/brands/get-brand-by-id/${id}`, {
        headers: header,
      });
      return response?.data;
    } catch (error) {
      return error?.response?.data || {
        message: error?.message || 'Failed to fetch brand',
        statusCode: error?.response?.status || 500,
      };
    }
  };
}

export function getWholesaler(id) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setSelectedBrand({}));

      const response = await axios.get(`${API_URL}/wholesaler/wholesaler-get/${id}`, {
        headers: header,
      });
      // // console.log(`${crmApiUrl}/leads/wholesaler-get/${id}`, response);
      if (response?.data?.statusCode === 200 && response?.data?.data) {
        dispatch(slice.actions.setSelectedBrand(response?.data?.data));
      }
    } catch (error) {
      // console.log("GET USER FAILD", error);
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getRetailer(id) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setSelectedBrand({}));

      const response = await axios.get(`${API_URL}/retailers/get/${id}`, {
        headers: header,
      });
      // // console.log(`${crmApiUrl}/leads/wholesaler-get/${id}`, response);
      if (response?.data?.statusCode === 200 && response?.data?.data) {
        dispatch(slice.actions.setSelectedBrand(response?.data?.data));
      }
    } catch (error) {
      // console.log("GET USER FAILD", error);
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}


export function getFilteredBrands(page = 1, query, filter, limit = 10) {
  return async (dispatch) => {
    // if (flag) {
    // } else {
    //   dispatch(slice.actions.startLoading());
    // }
    try {
      const response = await axios.get(
        `${AI_BACKEND_API}/brand/get_filtered_brands?page=${page}&limit=${limit}&filter=${filter || "New to old"}&search=${query || ""}`,
        {
          headers: header,
        }
      );

      // // console.log("GET FILTERED BRANDS RESPONSE", `${AI_BACKEND_API}/brand/get_filtered_brands?page=${page}&limit=10&filter=${filter || "New to old"}&search=${query || ""}`, response);
      if (response?.data.status === 200) {
        dispatch(
          slice.actions.getFilteredBrandsSuccess({
            page,
            total: response?.data?.data?.total,
            data: response?.data?.data?.brands,
          })
        );
        return response?.data?.data?.brands;
      }
    } catch (error) {
      // console.log("GET USER FAILD", error);
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getBrandScrappedData(data) {
  return async (dispatch, getState) => {
    try {
      dispatch(slice.actions.startLoading());

      // const state = getState(); // Access the Redux state

      // Check if the id is changed
      // if (state.brands.scrappedData.id !== data?.id) {
      //   dispatch(slice.actions.resetScrappedData());
      // }

      const response = await axios.post(`${AI_BACKEND_API_2}/get_scraped_data`, data, {
        headers: header,
      });
      // // console.log("GET SCRAPED DATA RESPONSE", response);

      if (response?.data?.status === 400 && response?.data?.message === "No Data Found") {
        dispatch(slice.actions.stopLoading());
        return "No Data Found Yet";
      }

      dispatch(
        slice.actions.getScrappedDataForBrandSuccess({
          id: data?.id,
          platform: data?.platform,
          scrappedData: response.data,
        })
      );
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function matchWholesaler(data) {
  return async (dispatch) => {
    try {
      // // console.log(data);
      const response = await axios.post(`${AI_BACKEND_API}/match/match_wholesalers`, data, {
        headers: header,
      });
      // // console.log("MATCH RESPONSE", response);

      if (response?.data.status === 400) {
        return toast.error(response?.data?.message);
      }

      if (response.data.status === 200) {
        if (response.data?.message === "No Wholesaler Matched") {
          toast.info(response.data?.message);
        } else {
          toast.success(response?.data?.message);
        }
      }

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getMatchResults(data) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startMatchingLoading());
      // // console.log("Get Matching Results Data", data);
      const response = await axios.post(`${AI_BACKEND_API_2}/get_match_results`, data, {
        headers: header,
      });
      // // console.log("Get Match Responsive", response);

      if (response.data?.status === 200) {
        dispatch(
          slice.actions.getMatchResultsSuccess(response?.data?.results)
        );
      } else {
        dispatch(slice.actions.hasError(response?.data?.message));
      }

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getBrandRating(brandId, ratingType) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${AI_BACKEND_API}/brand_rating/get_brand_rating?brand_id=${brandId}&rating_type=${ratingType}`, {
        headers: header,
      });

      // console.log("GET RATING", brandId, ratingType, response);
      if (response.data?.status === 200 || response.data?.status === 201) {
        await dispatch(getBrandRatingSuccess({ [ratingType]: response?.data?.data }));
      } else {
        await dispatch(getBrandRatingSuccess({ [ratingType]: null }));
      }

      return response?.data?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function updateBrandRating(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`https://fnadmatch.com/calculate_brand_rating/calculate_brand_rating`, data, {
        headers: header,
      });
      // // console.log("Update Brand Rating RESPONSE", response);

      if (response.data?.status >= 400) {
        toast.error(response?.data?.message);
      }

      if (response.data?.status === 200) {
        toast.success("Brand Rating Update");
      }

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function addUpdateWholesalerAgents(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/wholesaler/add-update-agents`, data, {
        headers: header,
      });
      console.log("ADD UPDATE AGENT RESPONSE", response);

      if (response.data?.statusCode >= 400) {
        toast.error(response?.data?.message);
      }

      if (response?.data?.statusCode === 200 && response?.data?.data) {
        toast.success(response?.data?.message);
        dispatch(slice.actions.setSelectedBrand(response?.data?.data));
      }

      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}


export function deleteBrands(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/brands/delete`, data, {
        headers: header,
      });
      console.log("DELETE BRANDS RESPONSE", response);

      if (response.data?.statusCode >= 400) {
        toast.error(response?.data?.message);
      }

      if (response?.data?.statusCode === 200 && response?.data?.data) {
        toast.success(response?.data?.message);
      }

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getBrandEngagements(brandId, tab, page = 1, take = 10) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startLoading());

      const payload = {
        brand_id: Number(brandId),
        tab: tab.toLowerCase(),
        skip: page,
        take,
      };

      const response = await axios.post(
        `${API_URL}/brands/get-brand-engagements`,
        payload,
        { headers: header }
      );

      console.log('GET BRAND ENGAGEMENTS RESPONSE', response.data);

      if (response?.data?.statusCode === 200) {
        dispatch(
          slice.actions.getBrandEngagementsSuccess({
            tab,
            page,
            total: response?.data?.data?.count || 0,
            data: response?.data?.data?.data || [],
          })
        );
        return response?.data;
      } else {
        dispatch(slice.actions.hasError(response?.data?.message));
        toast.error(response?.data?.message || "Failed to fetch brand engagements", { autoClose: 3000 });
        return response?.data;
      }
    } catch (error) {
      console.error('GET BRAND ENGAGEMENTS ERROR', error);
      toast.error(error?.response?.data?.message || error?.message || "Failed to fetch brand engagements", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function checkBrandDataExist(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/brands/check-brand-data-exist`, data, {
        headers: header,
      });
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getRetailerEngagements(retailerId, tab, page = 1, take = 10) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startLoading());

      const payload = {
        retailer_id: Number(retailerId),
        tab: tab.toLowerCase(),
        skip: page,
        take,
      };

      const response = await axios.post(
        `${API_URL}/retailers/get-retailer-engagements`,
        payload,
        { headers: header }
      );

      console.log('GET RETAILER ENGAGEMENTS RESPONSE', response.data);

      if (response?.data?.statusCode === 200) {
        dispatch(
          slice.actions.getRetailerEngagementsSuccess({
            tab,
            page,
            total: response?.data?.data?.count || 0,
            data: response?.data?.data?.data || [],
          })
        );
        return response?.data;
      } else {
        dispatch(slice.actions.hasError(response?.data?.message));
        toast.error(response?.data?.message || "Failed to fetch retailer engagements", { autoClose: 3000 });
        return response?.data;
      }
    } catch (error) {
      console.error('GET RETAILER ENGAGEMENTS ERROR', error);
      toast.error(error?.response?.data?.message || error?.message || "Failed to fetch retailer engagements", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getNextToBrands(nextToIds = []) {
  return async (dispatch, getState) => {
    const normalizedIds = Array.isArray(nextToIds)
      ? [...new Set(nextToIds.map((id) => Number(id)).filter((id) => Number.isInteger(id) && id > 0))]
      : [];

    const key = normalizedIds.join("-");

    if (!key) {
      return [];
    }

    const cachedData = getState()?.brands?.nextToBrandsByKey?.[key];
    if (cachedData) {
      return cachedData;
    }

    try {
      dispatch(slice.actions.startNextToBrandsLoading());

      const response = await axios.post(
        `${API_URL}/brands/get-next-to-brands`,
        { next_to_ids: normalizedIds },
        { headers: header }
      );

      if (response?.data?.statusCode === 200) {
        const data = response?.data?.data || [];
        dispatch(slice.actions.getNextToBrandsSuccess({ key, data }));
        return data;
      }

      dispatch(slice.actions.hasError(response?.data));
      return response?.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}
